import { Button } from '@99designs/common/components/Button';
import Box from 'projects/libs/core-components/Box/Box';
import * as React from 'react';
import Truncate from 'react-truncate';

interface ExpandableTextProps {
    text: string;
    expandLabel: string;
    onExpand?: () => void;
    isExpanded: boolean;
}

export default function ExpandableText({
    isExpanded,
    text,
    onExpand,
    expandLabel,
}: ExpandableTextProps) {
    return (
        <>
            <Box marginBottom="space5">
                {isExpanded ? (
                    <div className="paragraph paragraph--small paragraph--no-margin">{text}</div>
                ) : (
                    <div className="paragraph paragraph--small paragraph--no-margin">
                        <Truncate lines={2}>{text}</Truncate>
                    </div>
                )}
            </Box>
            <Button variations={['link']} onClick={onExpand}>
                <div className="paragraph paragraph--small paragraph--no-margin">{expandLabel}</div>
            </Button>
        </>
    );
}
